import React from 'react';
import styles from './content.module.scss';

class Content extends React.Component {
  render () {
    return (
      <div className={styles.content}>
        {this.props.title && (this.props.pageTitle ? <h1 className="text-center">{this.props.title}</h1> : <h2 className="text-center">{this.props.title}</h2>)}
        {this.props.image && <img className={styles.image} src={this.props.image} alt=""/>}
        {this.props.children}
      </div>
    )
  }
}

export default Content;


// WEBPACK FOOTER //
// ./src/components/Content/index.js